import { assertUnreachable } from '@ftr/contracts/shared/assertUnreachable'
import { GoldAudioOrderSttContext, goldAudioOrderSttContextEquals } from './gold-audio-order-stt-context'
import { GoldRecordingSttContext, goldRecordingSttContextEquals } from './gold-recording-stt-context'
import { GoldSharedRecordingSttContext, goldSharedRecordingSttContextEquals } from './gold-shared-recording-stt-context'

export type GoldSttContext = GoldAudioOrderSttContext | GoldRecordingSttContext | GoldSharedRecordingSttContext

export interface MatchSttContextFunctions<T> {
  mapAudioOrder: (x: GoldAudioOrderSttContext) => T
  mapRecording: (x: GoldRecordingSttContext) => T
  mapSharedRecording: (x: GoldSharedRecordingSttContext) => T
}

export function matchGoldSttContext<T>(
  context: GoldSttContext,
  { mapAudioOrder, mapRecording, mapSharedRecording }: MatchSttContextFunctions<T>,
): T {
  switch (context.type) {
    case 'audio-order':
      return mapAudioOrder(context)
    case 'recording':
      return mapRecording(context)
    case 'shared-recording':
      return mapSharedRecording(context)
    default:
      assertUnreachable(context)
  }
}

export function goldSttContextEquals(a: GoldSttContext, b: GoldSttContext): boolean {
  return matchGoldSttContext(a, {
    mapAudioOrder: goldAudioOrderSttContextEquals(b),
    mapRecording: goldRecordingSttContextEquals(b),
    mapSharedRecording: goldSharedRecordingSttContextEquals(b),
  })
}
